import { createApi } from 'api/common/createApi'
import config, { API_TYPES } from 'constants/api-config'

export const projectsApi = createApi({
  baseURL: config[API_TYPES.MT_API_URL],
})

export const api = createApi({
  baseURL: '/api',
})
